import { render, staticRenderFns } from "./ListOntologies.vue?vue&type=template&id=df3d4f32&scoped=true"
import script from "./ListOntologies.vue?vue&type=script&lang=js"
export * from "./ListOntologies.vue?vue&type=script&lang=js"
import style0 from "./ListOntologies.vue?vue&type=style&index=0&id=df3d4f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3d4f32",
  null
  
)

export default component.exports